import request from '@/api/request'
export default{
    getSubjects:params=>request.get('/subjects/getSubjects',{params})
}